import axios from "axios";
import tokenSync from "./tokenSync";

export const postFile = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 30000
});

const request = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 50000
});

// Request Interceptor: Inject token using tokenSync service
request.interceptors.request.use(
  config => {
    const token = tokenSync.getToken();
    if (token) {
      config.headers.Authorization = `Token ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

request.interceptors.response.use(
  res => {
    // Token Rotation: If server provided a new token, update via tokenSync
    const newToken = res.headers["x-new-authorization"];
    if (newToken) {
      tokenSync.updateToken(newToken);
    }
    return res;
  },
  err => {
    // Force token update even on errors (e.g. 403, 429) if header is present
    if (err.response && err.response.headers) {
      const newToken = err.response.headers["x-new-authorization"];
      if (newToken) {
        tokenSync.updateToken(newToken);
      }
    }

    if (
      err.response &&
      err.response.headers &&
      err.response.headers["content-type"] === "text/html" &&
      err.response.status === 403
    ) {
      location.reload();
    }
    throw err
  }
);

export default request;
